module.exports = __webpack_public_path__ + "img/xby.3634f1a4.svg";